import { useMutation } from '@tanstack/react-query';

export function useSortMasterActivityTradesMutation() {
  return useMutation({
    mutationFn: async ({ masterActivityTradeIds }) => {
      await axios.patch('/master_activity_trades/sort', {
        master_activity_trade: masterActivityTradeIds,
      });
    },
  });
}
